import { useEffect, useState } from "react";
import { LeaderboardApi } from "../../../api/LeaderboardApi";
import RankingLeaderboard from "./RankingLeaderboard";

const HEADING = "STEAiM-in-PE 比賽";
const SUB_HEADING = "最喜愛設計";

// Configurable refresh interval in milliseconds
const DEFAULT_REFRESH_INTERVAL = 2000;

export default function BestDesignLeaderboard({ refreshInterval = DEFAULT_REFRESH_INTERVAL, orgType = "primary", topRankCount = 3 }) {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);  
  const [error, setError] = useState(null);

  const orgTypeLabel = orgType === "primary" ? "小學" : orgType === "secondary" ? "中學" : "";

  useEffect(() => {
    loadLeaderboard();
        if (refreshInterval < 0) return;
  }, [refreshInterval]);

  const loadLeaderboard = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await LeaderboardApi.getTopSkillParticipantCount(orgType);
      const transformed = (result || []).map(
        ({ id, name_zh, name_en, code, rank, member_count }) => ({
          id,
          itemName: name_zh,
          itemNameEn: name_en,
          code,
          rank,
          score: member_count,
        })
      );
      setLeaderboardData(transformed.slice(0, topRankCount));
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (error) return null;

  return (
    <RankingLeaderboard
      heading={HEADING}
      subHeading={`${SUB_HEADING} (${orgTypeLabel})`}
      leaderboardData={leaderboardData}
      isLoading={isLoading}
    />
  );
}
